import React from 'react'
import { Typography, Box } from '@material-ui/core'

export const NotFound: React.FC = () => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='250px'
    >
      <Typography variant='h1'>Page Not Found</Typography>
    </Box>
    // <div>NotFound</div>
  )
}
